import ButtonPrimary from '../shared/Button/ButtonPrimary';
import { TbBrandWhatsapp } from "react-icons/tb";

export const Whatsapp = ({ content = [], info = "" }) => {
    const phoneNumber = '5491122867994';
    let message = "";

    if (info && info === "Problema de pago") {
        message = `Hola, tuve un problema con el pago de mi compra. ¿Me podrían ayudar?`;
    }
    else if (content.length === 1) {
        const texto = content
            .map((i) =>
                `- ${i.slug} ${i.quantity
                    ? `- ${i.quantity} Unidades\nDesde Mercado Pago = $${Math.round(i.quantity * i.price * 1.10)}\nDesde Transferencia = $${Math.round(i.quantity * i.price)}`
                    : `\nDesde Mercado Pago = $${Math.round(i.currentPrice * 1.10)}\nDesde Transferencia = $${i.currentPrice}`
                } \nhttps://capacut3d.com${i.url}`
            )
            .join('\n');
        message = `Hola, estoy interesado en el producto: \n${texto}`;
    }
    else if (Array.isArray(content) && content.length !== 0) {
        const texto = content
            .map((i) =>
                `- ${i.slug} $${i.price} ${i.quantity ? ' x ' + i.quantity + ' = $' + i.price * i.quantity : ''} \nhttps://capacut3d.com${i.url}`
            )
            .join('\n');
        const total = content.reduce((acc, item) => {
            return acc + item.price * item.quantity;
        }, 0);
        message = `Hola, estoy interesado en los productos: \n${texto}${content[0].quantity ? `\n\nTotal desde Mercado Pago: $${Math.round(total * 1.10)}\nTotal desde Transferencia: $${total}` : ''}`;
    }
    else {
        message = `Buenas Capacut3d, quería consultar sobre productos en impresión 3D y grabado. ¿Me podrían dar más info?`;
    }

    const handleClick = () => {
        const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(url, '_blank');
    };

    return (
        <ButtonPrimary
            className="w-full mt-4 border border-neutral-300 flex items-center justify-center gap-2"
            onClick={handleClick}
            ariaLabel='Consultar por Whatsapp'
        >
            <TbBrandWhatsapp className="text-2xl" />
            Consultar
        </ButtonPrimary>
    );
};

export default Whatsapp;
